import { createFileRoute } from "@tanstack/react-router";
import { ImagesList } from "../../features/storage/images-list";

export const Route = createFileRoute("/_authed/$org/$project/images/")({
  validateSearch: (s: Record<string, unknown>): { q?: string } => (typeof s.q === "string" && s.q ? { q: s.q } : {}),
  component: ImagesPage,
});

function ImagesPage() {
  const { org, project } = Route.useParams();
  return <ImagesList scope={{ org, project }} search={Route.useSearch()} />;
}
